<script>
    import Accordion from "./Accordion.svelte";
    import AccordionItem from "./AccordionItem.svelte";
    import PriceItem from "./PriceItem.svelte";
    import {_} from "svelte-i18n";
</script>

<style>
    .price-link {
        text-decoration: underline;
        color: var(--black-100);
    }
</style>

<Accordion let:setActive>
    <AccordionItem index="0" title={$_("adults")} {setActive}>
        <PriceItem hideTop>
            <div slot="left">{$_("adults")}</div>
            <div slot="right">CHF 25</div>
        </PriceItem>
        <PriceItem hideTop>
            <div slot="left">{$_("tuesday_discount")}</div>
            <div slot="right">CHF 20</div>
        </PriceItem>
    </AccordionItem>
    <AccordionItem index="1" title={$_("teens")} {setActive}>
        <PriceItem hideTop>
            <div slot="left">{$_("teens_age")}</div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
    </AccordionItem>
    <AccordionItem index="2" title={$_("tourism")} {setActive}>
        <PriceItem hideTop>
            <div slot="left">
                {$_("combi_1")} <br>
                <a class="price-link"
                   href={$_("combi_1_offer_link")}>{$_("combi_1_offer")}</a>
            </div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("combi_2")}<br>
                <a class="price-link"
                   href={$_("combi_2_offer_link")}>{$_("combi_2_offer")}</a>
            </div>
        </PriceItem>
    </AccordionItem>
    <AccordionItem index="3" title={$_("disabled")} {setActive}>
        <PriceItem hideTop>
            <div slot="left">
                {$_("disabled_iv")}
            </div>
            <div slot="right">CHF 20</div>
        </PriceItem>
        <PriceItem hideTop>
            <div slot="left">
                {$_("disabled_assistant")}
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <a href={$_("disabled_information_link")}
           style="margin-top:6px; display: block" class="price-link">{$_("disabled_information")}</a>
    </AccordionItem>
    <AccordionItem {setActive} index="4" title={$_("groups_and_classes")}>
        <PriceItem>
            <div style="font-weight: bold" slot="left">
                {$_("groups")}
            </div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("groups_20")}
            </div>
            <div slot="right">CHF 20
                {$_("per_person")}
            </div>
        </PriceItem>
        <div style="margin-top:6px;margin-bottom: 24px"><a class="price-link"
                                                           href={$_("group_information_link")}>{$_("group_information")}</a>
        </div>
        <PriceItem>
            <div style="font-weight: bold" slot="left">
                {$_("classes")}
            </div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                <a class="price-link" href={$_("registration_required_link")}>{$_("registration_required")}</a>
            </div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("students")}
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("additional_persons")}
            </div>
            <div slot="right">CHF 25</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                <a class="price-link" href={$_("classes_additional_information_link")}>
                    {$_("classes_additional_information")}
                </a>
            </div>
        </PriceItem>
    </AccordionItem>
    <AccordionItem index="5" title={$_("prices_discount")} {setActive}>
        <div style="margin-bottom: 12px" class="text-l">
            {$_("following_discount")}
        </div>
        <PriceItem>
            <div slot="left">
                {$_("artCard")}
            </div>
            <div slot="right">CHF 20</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                BaselCard
            </div>
            <div slot="right">CHF 12.50</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("blkb_over_30")}
            </div>
            <div slot="right">CHF 20</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                Caritas Kultur Legi
            </div>
            <div slot="right">CHF 15</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                Freiwilliger Museumsverein Basel
            </div>
            <div slot="right">CHF 20</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("guest_pass")}
            </div>
            <div slot="right">CHF 20</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("iv")}
            </div>
            <div slot="right">CHF 20</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("adac")}
            </div>
            <div slot="right">CHF 20</div>
        </PriceItem>
        <div class="text-l" style="margin-top: 12px">
            {$_("no_raiffeisen")} <br>
            {$_("no_museumspass")}
        </div>
    </AccordionItem>
    <AccordionItem title={$_("free_entry")} index="6" {setActive}>
        <div style="margin-bottom: 12px" class="text-l">
            {$_("free_entry_info")}
        </div>
        <PriceItem>
            <div slot="left">
                Art Club & Young Art Club
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("basel_tourism")}
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("blkb_under_30")}
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                Colorkey
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("cimam")}
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("friends")}
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                Guggenheim Art Pass
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                iaa-aiap
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                ICOM
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("seminar_students")}
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                MPM MuseumsPassMusée
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                Musées sans frontières
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                Sotheby's Preferred
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                Verband Museen Schweiz (VMS)
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("vitra")}
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
        <PriceItem>
            <div slot="left">
                {$_("refugees")}
            </div>
            <div slot="right">{$_("free_entry")}</div>
        </PriceItem>
    </AccordionItem>
</Accordion>
